<div class="app-component-container" id="cards-gallery">
    <div class="content">
        <app-s-header [elemIds]="elementSignals['component-header']()"></app-s-header>
    </div>
    <div class="contact-items" [ngClass]="{'large-screen': isLargeScreen$()}">
        <app-base-cards-contact></app-base-cards-contact>
        <app-base-cards-info></app-base-cards-info>
    </div>
</div>
